// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"legendImg-module--mainImage--3KxzK"};